import axios from 'axios'
import { Message } from 'element-ui'
// import store from '@/store'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://xingbaogao.com/api',
  // baseURL: 'http://121.43.97.86:8080',
  // baseURL: 'http://localhost:8080',
  // baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:8080',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 如果有token，添加到请求头
    // if (store.getters.token) {
    //   config.headers['Authorization'] = 'Bearer ' + store.getters.token
    // }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 根据后端返回的数据结构进行处理
    if (res.code !== 200 && res.code !== 0) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })

      // 401: 未登录或token过期
      // if (res.code === 401) {
      // // 跳转到登录页
      // store.dispatch('user/logout').then(() => {
      //   location.reload()
      // })
      // }
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    console.error('Response error:', error)
    Message({
      message: error.message || '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
